<nz-card>
  @switch (contentType) {
    @case ('gift-card') {
      <app-gift-card-content [isModal]="isModal" (closeRequested)="onCloseRequested()"></app-gift-card-content>
    }
    @case ('request-appointment') {
      <h2 nz-typography class="text-lg !mb-6 text-center">{{ 'shared.labels.book-an-appointment' | translate }}</h2>
      <app-request-appointment />
    }
    @default {
      <app-cart-content [isModal]="isModal" (closeRequested)="onCloseRequested()"></app-cart-content>
    }
  }
</nz-card>
